import React from 'react';

/** This component is used as
 * a marker to allow finding it's parent (SharedOptions wrapper)
 *  to apply styles to, in this case in order to
 *  fill up remaining space of the component */
const DynamicSeparator = () => <div className="dynamic-separator" />;

export default DynamicSeparator;
